import React, { useState } from "react";
import AFController from "./AFController";
import "../7ALoading/sevenA.css";
import AssetMap from "./AssetMap";
import AssetRemark from "./AssetComp/AssetRemarks";
import DataSummary from "./AssetComp/DataSummary";
import AssetNavbar from "./AssetNavbar";
import OverviewMaster from "./OverviewMaster";
import AFSummary from "./AssetComp/AFSummary";
import { flattenData } from "../../Utilitie";
import GroupedTrendChart from "../../CHARTS/GroupedTrendChart";

const AssetFailureMaster = () => {
  const [filteredAF, setFilteredAF] = useState(null);
  const [aFData, setAFData] = useState(null);
  const [openStates, setOpenStates] = useState({
    Year: "",
    "Asset Group": "",
    "Main Cause": "",
    "Sub Cause": "",
    Month: "",
    "Line Up Down": "",
    Shift: "",
    Section: "",
    "Block Station": "",
  });
  const [treeMapPath, setTreeMapPath] = useState({
    F_YEAR: "",
    ASSET_GROUP: "",
    MAIN_CAUSE_DESC: "",
    SUB_CAUSE_DESC: "",
    Month: "",
  });
  const [activePage, setActivePage] = useState("Overview");
  const tempData = filteredAF && flattenData(filteredAF);
  const subCause = tempData && [...new Set(tempData.map((o) => o.SUB_CAUSE))];
  // console.log(tempData);
  // console.log(subCause);
  let timeSum = [];

  if (tempData && subCause) {
    subCause.forEach((sc) => {
      const fdata = tempData.filter((o) => o.SUB_CAUSE === sc);
      const totalTime = fdata.reduce(
        (sum, obj) => sum + obj.AVARAGE_DET_TOTAL_TIME,
        0
      );
      const months = [...new Set(fdata.map((o) => o.A_MONTH))];
      const monthWise = months.map((m) => {
        const monthData = fdata.filter((o) => o.A_MONTH === m);
        const monthTime = monthData.reduce(
          (sum, obj) => sum + obj.AVARAGE_DET_TOTAL_TIME,
          0
        );
        return { month: m, time: monthTime };
      });

      timeSum.push({
        subCause: sc,
        totalTime,
        months,
        monthWise,
      });
    });
  }

  return (
    <div>
      <div className="sticky-controller">
        <AFController
          openStates={openStates}
          setFilteredAF={setFilteredAF}
          setOpenStates={setOpenStates}
          setAFData={setAFData}
        />
      </div>
      {/* ////////////////////////////////////////////////////////////////////////////////////////// */}
      <div>
        <AssetNavbar activePage={activePage} setActivePage={setActivePage} />
      </div>
      <div
        style={{ minHeight: "90vh" }}
        onClick={() => {
          setOpenStates({
            Year: false,
            "Asset Group": false,
            "Main Cause": false,
            "Sub Cause": false,
            Month: false,
            "Line Up Down": false,
            Shift: false,
            Section: false,
            "Block Station": false,
          });
        }}
      >
        {filteredAF && activePage === "Asset remark" && (
          <div className="fade-in-up">
            <div className="row m-1">
              <div className="col-md">
                <AssetMap data={filteredAF} setTreeMapPath={setTreeMapPath} />
              </div>
              {/* {filteredAF && filteredAF.length >= 2 && (
            <div className="col-md">
              <AssetMap data={filteredAF} second={true} />
            </div>
          )} */}
            </div>{" "}
            <div className="row m-1">
              <div className="col-md-2 ">
                <div className="newUiBody" style={{ height: "100%" }}>
                  <DataSummary
                    data={filteredAF}
                    fy={filteredAF && filteredAF[0]?.F_YEAR}
                  />
                </div>
              </div>
              <div className="col-md-10 ">
                <AssetRemark data={filteredAF} path={treeMapPath} />
              </div>
            </div>
          </div>
        )}
        {filteredAF && activePage === "Overview" && (
          <div className="fade-in-up">
            {" "}
            <OverviewMaster data={filteredAF} />
          </div>
        )}
        {filteredAF && activePage === "Summary" && (
          <div className="fade-in-up">
            {" "}
            <AFSummary data={filteredAF} />
          </div>
        )}
        {/* {filteredAF && timeSum.length > 0 && (
          <div className="fade-in-up mt-3 p-2">
            <h5 className="text-center fw-bold mb-3">
              Sub-Cause Monthwise Trend
            </h5>
            <GroupedTrendChart data={tempData} />
          </div>
        )} */}
      </div>{" "}
    </div>
  );
};
export default AssetFailureMaster;
